import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 8H10.8L9.4 10.25H6.6L5.2 8H1M15 8V12.5C15 12.8978 14.8525 13.2794 14.5899 13.5607C14.3274 13.842 13.9713 14 13.6 14H2.4C2.0287 14 1.6726 13.842 1.41005 13.5607C1.1475 13.2794 1 12.8978 1 12.5V8M15 8L12.585 2.8325C12.4691 2.58259 12.2904 2.37228 12.0691 2.22521C11.8477 2.07814 11.5925 2.00015 11.332 2H4.668C4.40754 2.00015 4.15228 2.07814 3.93093 2.22521C3.70958 2.37228 3.5309 2.58259 3.415 2.8325L1 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;